import { fmtNum } from "@/lib/api";

export const MatrixTable = ({ matrix, ratings }) => (
  <div className="grid xl:grid-cols-[1fr_260px] gap-5" data-testid={`matrix-panel-${matrix.id}`}>
    <div className="scroll-x">
      <table className="w-full text-sm" data-testid={`matrix-table-${matrix.id}`}>
        <thead>
          <tr className="text-left eyebrow border-b border-slate-800">
            <th className="px-3 py-2.5 font-normal">#</th>
            <th className="px-3 py-2.5 font-normal">Runner</th>
            <th className="px-3 py-2.5 font-normal text-right">Raw Data</th>
            <th className="px-3 py-2.5 font-normal text-right">Matched Band</th>
            <th className="px-3 py-2.5 font-normal text-right">Points</th>
            <th className="px-3 py-2.5 font-normal text-right">× Weight</th>
            <th className="px-3 py-2.5 font-normal text-right">Score</th>
          </tr>
        </thead>
        <tbody>
          {[...ratings].sort((a, b) => b.scores[matrix.id].weighted - a.scores[matrix.id].weighted).map((r) => {
            const s = r.scores[matrix.id];
            return (
              <tr key={r.name} className="row-hover border-b border-slate-800/60">
                <td className="px-3 py-2.5 num text-slate-500">{r.number ?? "-"}</td>
                <td className="px-3 py-2.5 text-white">{r.name}</td>
                <td className="px-3 py-2.5 num text-right text-cyan-300">{s.value == null ? <span className="text-slate-600">no data</span> : fmtNum(s.value, 2)}</td>
                <td className="px-3 py-2.5 num text-right text-slate-400">{s.band || "—"}</td>
                <td className="px-3 py-2.5 num text-right">{fmtNum(s.points, 2)}</td>
                <td className="px-3 py-2.5 num text-right text-slate-500">{fmtNum(matrix.weight, 2)}</td>
                <td className="px-3 py-2.5 num text-right font-bold text-emerald-400">{fmtNum(s.weighted, 2)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
    <div className="bg-[#0F172A] border border-slate-800 rounded p-4 h-fit">
      <div className="eyebrow mb-1">Matrix Table</div>
      <div className="text-xs text-slate-400 mb-3">Field: <span className="num text-cyan-300">{matrix.field}</span> • Weight <span className="num">{matrix.weight}</span></div>
      {matrix.mode === "grid" ? <p className="text-xs text-slate-300">{{ track_starts: "Track record (starts / wins at this course)", dist_starts: "Distance record (starts / wins at this distance)",
          firstup_starts: "1st Up record, used only when the horse is resuming from a spell (form ends in x),",
          secondup_starts: "2nd Up record, used only at the second run back from a spell (form ends in x + one run),",
          slow_starts: "Soft record, used only when the track is rated 6–7 (otherwise 0),", heavy_starts: "Heavy record, used only when the track is rated Heavy 8–10 (otherwise 0),", }[matrix.field] || "Career record"} {["slow_starts", "heavy_starts"].includes(matrix.field) ? "places (1st + 2nd + 3rd) read as the wins rows" : "wins"} × starts looked up in the same Win Score grid (Rules &amp; Matrices → Rating Rules). Over 20 starts: wins scaled to a 20-start equivalent. No starts = 0.</p> : matrix.mode === "linear" ? <p className="text-xs text-slate-300">Points = raw value (1 point per unit) × weight.{matrix.field === "weight_drop" && " Positive = lighter today than last start, negative = heavier."}{matrix.field === "class_drop" && " Last start class score − this race class score: positive = dropping in class, negative = rising in class."}{matrix.field === "ls_margin_penalty" && " Lengths beaten last start × weight as a penalty (e.g. beaten 4L × 0.75 = −3). Winners score 0."}</p> : (
      <table className="w-full text-xs num">
        <thead>
          <tr className="text-slate-500 text-left"><th className="py-1 font-normal">Min</th><th className="py-1 font-normal">Max</th><th className="py-1 font-normal text-right">Pts</th></tr>
        </thead>
        <tbody>
          {matrix.bands.map((b, i) => (
            <tr key={i} className="border-t border-slate-800">
              <td className="py-1.5">{b.min ?? "−∞"}</td>
              <td className="py-1.5">{b.max ?? "∞"}</td>
              <td className="py-1.5 text-right text-amber-400">{b.points}</td>
            </tr>
          ))}
        </tbody>
      </table>
      )}
    </div>
  </div>
);
